/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable from "@insite/mobius/DataTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import {
    Button,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
    Link,
    TextField,
    Typography,
} from "@insite/mobius/index";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { withHistory } from "@insite/mobius/utilities/HistoryContext";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext, useEffect, useState } from "react";
import { css } from "styled-components";

const enum fields {
    panelGuard = "panelGuard",
    pDFFileName = "pDFFileName",
    pDFPartNumber = "pDFPartNumber",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.panelGuard]: PanelGuardModel[];
        [fields.pDFFileName]: string;
        [fields.pDFPartNumber]: string;
    };
}
interface PanelGuardModel {
    fields: {
        dropdownOptions: ActionModel[];
        title: string;
        name: string;
        isRequired: boolean;
        incluededInDynamicPartNumber: boolean;
    };
}

export interface ActionModel {
    fields: Fields2;
}

export interface Fields2 {
    label: string;
    value: string;
    description: string;
    key: string;
    id: string;
    dependencyDropDown: boolean;
    KAValue: string;
}

type Props = OwnProps & HasHistory;

export interface PanelGuardStyles {
    container?: InjectableCss;
    leftContainer?: InjectableCss;
    rightContainer?: InjectableCss;
    dropdownSelect?: SelectPresentationProps;
    tableContainer?: InjectableCss;
    tableContainer2?: InjectableCss;
    heading?: InjectableCss;
    rowCells?: InjectableCss;
    subHeading?: InjectableCss;
    required?: InjectableCss;
    requestForQuote?: ButtonPresentationProps;
    buttonWrapper?: InjectableCss;
    columnCells?: InjectableCss;
    orderPartCell?: InjectableCss;
}

export const panelGuardStyles: PanelGuardStyles = {
    container: {
        css: css`
            display: flex;
            padding-bottom: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    leftContainer: {
        css: css`
            flex-basis: 40%;
            max-width: 40%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    required: {
        css: css`
            div[class^="FormFieldStyle"]:last-child {
                padding-bottom: 25px;
            }
        `,
    },
    rightContainer: {
        css: css`
            flex-basis: 60%;
            max-width: 60%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-top: 30px;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-top: 30px;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-top: 30px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    tableContainer: {
        css: css`
            width: 100%;
            overflow: auto;
            padding-bottom: 20px;
            padding-top: 15px;
        `,
    },
    tableContainer2: {
        css: css`
            width: 100%;
            overflow: auto;
            padding-bottom: 20px;
        `,
    },
    heading: {
        css: css`
            font-size: 18px;
            font-weight: bold;
            letter-spacing: 1px;
        `,
    },
    dropdownSelect: {
        cssOverrides: {
            formField: css`
                display: flex;
                flex-direction: row;
                align-items: center;
                label {
                    width: 25%;
                    font-size: 16px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            label {
                                width: 30%;
                            }
                        `,
                        css`
                            label {
                                width: 30%;
                            }
                        `,
                        css`
                            label {
                                width: 30%;
                            }
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 65%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 70%;
                        `,
                        css`
                            width: 70%;
                        `,
                        css`
                            width: 70%;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    rowCells: {
        css: css`
            th {
                background: #f4f6fa;
                width: 33.333%;
                span {
                    font-size: 16px;
                }
            }
        `,
    },
    columnCells: {
        css: css`
            td {
                width: 33.333%;
            }
        `,
    },
    subHeading: {
        css: css`
            margin-bottom: 10px;
            span {
                font-size: 22px;
                font-weight: 600;
            }
        `,
    },
    orderPartCell: {
        css: css`
            width: 220px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 150px;
                    `,
                    css`
                        width: 150px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding-top: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        justify-content: center;
                    `,
                    css`
                        flex-direction: column;
                        justify-content: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    requestForQuote: {
        mergeCss: true,
        css: css`
            &:disabled {
                background: #cccccc !important;
                border-color: #cccccc !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 10px;
                    `,
                    css`
                        margin-bottom: 10px;
                    `,
                    null,
                    css`
                        padding: 0px 12px !important;
                        span {
                            font-size: 11px !important;
                        }
                    `,
                    null,
                ])}
        `,
    },
};

export const styles = panelGuardStyles;

type Data = {
    [key: string]: OptionModel;
};

type OptionModel = {
    label?: string;
    value?: string;
    description?: string;
    key?: string;
    KAValue?: string;
    id?: string;
};

type OptionsArr = {
    fields: OptionModel;
}[];

type tableRow = {
    label: string;
    partNumber: string;
    description: string;
    pdfValue: string;
};

const INTPanelGuard: React.FC<Props> = ({ fields, history }) => {
    const { panelGuard, pDFFileName, pDFPartNumber } = fields;
    const [data, setData] = useState<Data>({});
    const [tableRows, setTableRows] = useState<tableRow[]>([]);
    const [tableRows1, setTableRows1] = useState<tableRow[]>([]);
    const [currentPartNumber, setCurrentPartNumber] = useState(1);

    useEffect(() => {
        generateTableRows();
        updatePartNumberRows(currentPartNumber);
    }, [data]);

    useEffect(() => {
        generatePartNumberRows();
    }, []);

    const getValue = (name: string) => {
        return data[name]?.id || "";
    };

    const getAnotherPartNumber = () => {
        setCurrentPartNumber(currentPartNumber + 1);
        setData({});
    };

    let disablePartNumberButton = false;
    if (currentPartNumber === 3) {
        disablePartNumberButton = true;
    }

    let emptyValue = false;

    if (
        !data?.protection?.value ||
        !data?.KA?.value ||
        !data?.filtering?.value ||
        !data?.voltage?.value ||
        !data?.dignostic?.value
    ) {
        emptyValue = true;
    }

    const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>, name: string, optionsArr: OptionsArr) => {
        let selectedOption: OptionModel = {};

        optionsArr.forEach(item => {
            if (item.fields.id === event.target.value) {
                selectedOption = item.fields;
            }
        });

        switch (name) {
            case "protection":
                return setData({
                    ...data,
                    [name]: selectedOption,
                    KA: { value: "" },
                });
            case "KA":
                return setData({
                    ...data,
                    [name]: selectedOption,
                    disconnect: { value: "" },
                });
            default:
                return setData({
                    ...data,
                    [name]: selectedOption,
                });
        }
    };

    const resetData = () => {
        setData({});
        setTableRows1([]);
        generatePartNumberRows();
        setCurrentPartNumber(1);
    };

    const requestQuote = () => {
        const panelguard_part__ = tableRows1.map(t => t.partNumber);
        const panelguard_description = tableRows1.map(t => t.description);

        if (currentPartNumber === 1) {
            window.open(
                `/Resources/PANELGUARD-configurator/RequestForQuote?panelguard_part__=${panelguard_part__[0]}&panelguard_description=${panelguard_description[0]}`,
                "_blank",
            );
        } else if (currentPartNumber === 2) {
            window.open(
                `/Resources/PANELGUARD-configurator/RequestForQuote?panelguard_part__=${panelguard_part__[0]}&panelguard_description=${panelguard_description[0]}&panelguard_part_number__2_=${panelguard_part__[1]}&panelguard_description__2_=${panelguard_description[1]}`,
            );
        } else {
            window.open(
                `/Resources/PANELGUARD-configurator/RequestForQuote?panelguard_part__=${panelguard_part__[0]}&panelguard_description=${panelguard_description[0]}&panelguard_part_number__2_=${panelguard_part__[1]}&panelguard_description__2_=${panelguard_description[1]}&panelguard_part_number__3_=${panelguard_part__[2]}&panelguard_description__3_=${panelguard_description[2]}`,
            );
        }
    };

    const generateTableRows = () => {
        const firstRow = generateFirstTableRow();
        const otherRows = generateOtherTableRows();
        const rows = [firstRow, ...otherRows];
        setTableRows(rows);
    };

    const updatePartNumberRows = (partNumber: number) => {
        let activeDescription = "";
        let activePartNumber = "";
        let pdfValue = "";

        panelGuard.forEach(panel => {
            if (panel.fields.incluededInDynamicPartNumber) {
                const obj = data[panel.fields.name];
                if (obj?.description) {
                    activeDescription += `${obj.description} `;
                }
            }
        });

        panelGuard.forEach(panel => {
            const obj = data[panel.fields.name];
            if (obj?.value) {
                activePartNumber += obj.value;
            }
        });

        const PDFArray = pDFFileName?.split(",")?.map(value => value?.trim()?.replace(/"/g, ""));

        const dynamicPartNumber = activePartNumber?.match(/(M\d+S)|(P\d+)/)?.[0] || "";

        const dynamicValues = pDFPartNumber?.split(",").map(value => value.trim().replace(/"/g, ""));

        if (activePartNumber && dynamicValues?.includes(dynamicPartNumber)) {
            const matchingPDF = PDFArray?.find(pdf => pdf?.includes(dynamicPartNumber) && pdf !== activePartNumber);

            if (matchingPDF) {
                pdfValue = `/userFiles/seriesPDF/${matchingPDF?.trim()}.pdf`;
            }
        }

        const orderPartNumberRowsCopy = [...tableRows1];
        orderPartNumberRowsCopy[partNumber - 1] = {
            ...orderPartNumberRowsCopy[partNumber - 1],
            partNumber: activePartNumber,
            description: activeDescription,
            // eslint-disable-next-line object-shorthand
            pdfValue: pdfValue,
        };
        setTableRows1(orderPartNumberRowsCopy);
    };

    const generatePartNumberRows = () => {
        const orderRows1 = generateOrderRows(1);
        const orderRows2 = generateOrderRows(2);
        const orderRows3 = generateOrderRows(3);
        const rows = [orderRows1, orderRows2, orderRows3];
        setTableRows1(rows);
    };

    const generateFirstTableRow = () => {
        const rowObj = {
            label: "Base Unit",
            partNumber: "",
            description: "",
            pdfValue: "",
        };

        panelGuard.forEach(panel => {
            if (panel.fields.incluededInDynamicPartNumber) {
                const obj = data[panel.fields.name];
                if (obj?.value) {
                    rowObj.partNumber += obj.value;
                }
                if (obj?.description) {
                    rowObj.description += `${obj.description} `;
                }
            }
        });
        return rowObj;
    };

    const generateOtherTableRows = () => {
        const otherRows: tableRow[] = [];
        panelGuard.forEach(panel => {
            const rowObj = {
                label: panel.fields.title,
                partNumber: "",
                description: "",
                pdfValue: "",
            };
            if (!panel.fields.incluededInDynamicPartNumber) {
                const obj = data[panel.fields.name];
                if (obj?.value) {
                    rowObj.partNumber = obj.value;
                }
                if (obj?.description) {
                    rowObj.description = obj.description;
                }
                otherRows.push(rowObj);
            }
        });
        return otherRows;
    };

    const generateOrderRows = (orderPartNumber: number) => {
        const orderObj = {
            label: `Ordering Part# ${orderPartNumber}`,
            partNumber: "",
            description: "",
            pdfValue: "",
        };

        return orderObj;
    };

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.leftContainer}>
                <StyledWrapper {...styles.required}>
                    <StyledWrapper {...styles.subHeading}>
                        <Typography>{translate("Required")}</Typography>
                    </StyledWrapper>
                    {panelGuard.map(panel => {
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <>
                                {panel.fields.incluededInDynamicPartNumber &&
                                    (panel.fields.name === "KA" ? (
                                        <Select
                                            {...styles.dropdownSelect}
                                            label={panel.fields.title}
                                            required={panel.fields.isRequired}
                                            value={getValue(panel.fields.name)}
                                            onChange={e =>
                                                onChangeHandler(e, panel.fields.name, panel.fields.dropdownOptions)
                                            }
                                        >
                                            {panel.fields.dropdownOptions && data.protection?.value
                                                ? panel.fields.dropdownOptions
                                                      .filter(item => item.fields.key === data.protection.value)
                                                      .map((p, i: number) => {
                                                          return (
                                                              <option key={i} value={p.fields.id}>
                                                                  {p.fields.label}
                                                              </option>
                                                          );
                                                      })
                                                : panel.fields.dropdownOptions
                                                      .filter(item => item.fields.key === "")
                                                      .map((p, i: number) => {
                                                          return (
                                                              <option key={i} value={p.fields.value}>
                                                                  {p.fields.label}
                                                              </option>
                                                          );
                                                      })}
                                        </Select>
                                    ) : (
                                        <Select
                                            {...styles.dropdownSelect}
                                            label={panel.fields.title}
                                            required={panel.fields.isRequired}
                                            value={getValue(panel.fields.name)}
                                            onChange={e =>
                                                onChangeHandler(e, panel.fields.name, panel.fields.dropdownOptions)
                                            }
                                        >
                                            {panel.fields.dropdownOptions &&
                                                panel.fields.dropdownOptions.map((p, i: number) => {
                                                    return (
                                                        <option key={i} value={p.fields.id}>
                                                            {p.fields.label}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    ))}
                            </>
                        );
                    })}
                </StyledWrapper>
                <>
                    <StyledWrapper {...styles.subHeading}>
                        <Typography>Optional</Typography>
                    </StyledWrapper>
                    {panelGuard.map(panel => {
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <>
                                {!panel.fields.incluededInDynamicPartNumber &&
                                    (panel.fields.name === "disconnect" ? (
                                        <Select
                                            {...styles.dropdownSelect}
                                            label={panel.fields.title}
                                            required={panel.fields.isRequired}
                                            value={getValue(panel.fields.name)}
                                            onChange={e =>
                                                onChangeHandler(e, panel.fields.name, panel.fields.dropdownOptions)
                                            }
                                        >
                                            {panel.fields.dropdownOptions && data.KA?.value
                                                ? panel.fields.dropdownOptions
                                                      .filter(item => {
                                                          if (data.KA?.key === "M") {
                                                              if (
                                                                  Number(data.KA?.KAValue) < 240 &&
                                                                  Number(item.fields.KAValue) > 0 &&
                                                                  Number(item.fields.KAValue) < 240
                                                              ) {
                                                                  return true;
                                                              }
                                                              if (
                                                                  item.fields.key === "M" &&
                                                                  Number(data.KA?.KAValue) >= 240 &&
                                                                  Number(item.fields.KAValue) >= 240
                                                              ) {
                                                                  return true;
                                                              }
                                                          }
                                                          if (data.KA?.key === "P") {
                                                              if (
                                                                  item.fields.key === "P" &&
                                                                  Number(data.KA?.KAValue) <= 300 &&
                                                                  Number(item.fields.KAValue) > 0 &&
                                                                  Number(item.fields.KAValue) <= 300
                                                              ) {
                                                                  return true;
                                                              }
                                                              if (
                                                                  Number(data.KA?.KAValue) > 300 &&
                                                                  Number(item.fields.KAValue) > 300
                                                              ) {
                                                                  return true;
                                                              }
                                                          }

                                                          return false;
                                                      })
                                                      .map((p, i: number) => {
                                                          return (
                                                              // eslint-disable-next-line react/no-array-index-key
                                                              <option key={i} value={p.fields.id}>
                                                                  {p.fields.label}
                                                              </option>
                                                          );
                                                      })
                                                : panel.fields.dropdownOptions
                                                      .filter(item => item.fields.KAValue === "")
                                                      .map((p, i: number) => {
                                                          return (
                                                              // eslint-disable-next-line react/no-array-index-key
                                                              <option key={i} value={p.fields.id}>
                                                                  {p.fields.label}
                                                              </option>
                                                          );
                                                      })}
                                        </Select>
                                    ) : (
                                        <Select
                                            {...styles.dropdownSelect}
                                            label={panel.fields.title}
                                            required={panel.fields.isRequired}
                                            value={getValue(panel.fields.name)}
                                            onChange={e =>
                                                onChangeHandler(e, panel.fields.name, panel.fields.dropdownOptions)
                                            }
                                        >
                                            {panel.fields.dropdownOptions &&
                                                panel.fields.dropdownOptions.map((p, i: number) => {
                                                    return (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <option key={i} value={p.fields.id}>
                                                            {p.fields.label}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    ))}
                            </>
                        );
                    })}
                </>
            </StyledWrapper>
            <StyledWrapper {...styles.rightContainer}>
                <StyledWrapper {...styles.tableContainer}>
                    <DataTable>
                        <DataTableHead {...styles.rowCells}>
                            <DataTableHeader>{translate("")}</DataTableHeader>
                            <DataTableHeader>{translate("")}</DataTableHeader>
                            <DataTableHeader>{translate("Description")}</DataTableHeader>
                        </DataTableHead>
                        <DataTableBody>
                            {tableRows.map((row: tableRow) => {
                                return (
                                    <DataTableRow key={row.label} {...styles.columnCells}>
                                        <DataTableCell>{translate(row.label)}</DataTableCell>
                                        <DataTableCell>{row.partNumber}</DataTableCell>
                                        <DataTableCell>{row.description}</DataTableCell>
                                    </DataTableRow>
                                );
                            })}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
                <StyledWrapper
                    css={css`
                        margin-top: 40px;
                    `}
                ></StyledWrapper>
                <StyledWrapper {...styles.tableContainer2}>
                    <DataTable>
                        <DataTableBody>
                            {tableRows1.map((row: tableRow, index: number) => {
                                const isFirstRow = index === 0;
                                const rowStyles = isFirstRow ? { borderTop: "1px solid #CCCCCC" } : {};
                                const hasPdfValue = row.pdfValue && row.pdfValue !== "";
                                return (
                                    <DataTableRow key={row.label} style={rowStyles}>
                                        <DataTableCell {...styles.orderPartCell}>{translate(row.label)}</DataTableCell>
                                        <DataTableCell {...styles.orderPartCell}>{row.partNumber}</DataTableCell>

                                        <DataTableCell>
                                            <Link
                                                css={css`
                                                    span {
                                                        font-size: 16px;
                                                        font-weight: 500;
                                                    }
                                                `}
                                                target="_blank"
                                                href={row.pdfValue}
                                            >
                                                {hasPdfValue ? translate("Download Spec sheet") : ""}
                                            </Link>
                                        </DataTableCell>
                                    </DataTableRow>
                                );
                            })}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>

                <StyledWrapper {...styles.buttonWrapper}>
                    <Button {...styles.requestForQuote} onClick={() => requestQuote()} disabled={emptyValue}>
                        SUBMIT FOR QUOTE
                    </Button>
                    <Button
                        {...styles.requestForQuote}
                        onClick={getAnotherPartNumber}
                        disabled={emptyValue || disablePartNumberButton}
                    >
                        CONFIGURE ANOTHER PART #
                    </Button>
                    <Button {...styles.requestForQuote} onClick={resetData}>
                        RESET FORM
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(INTPanelGuard),
    definition: {
        displayName: "PanelGuard",
        group: "Common",

        fieldDefinitions: [
            {
                name: fields.panelGuard,
                displayName: "Panel Guard",
                editorTemplate: "ListField",
                defaultValue: [],
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "title",
                        displayName: "Title",
                        defaultValue: "",
                        editorTemplate: "TextField",
                    },
                    {
                        name: "name",
                        displayName: "Name",
                        defaultValue: "",
                        editorTemplate: "TextField",
                    },
                    {
                        name: "dropdownOptions",
                        displayName: "Drop Down Options",
                        editorTemplate: "ListField",
                        defaultValue: [],
                        getDisplay: (item: HasFields) => {
                            return item.fields.label;
                        },
                        fieldDefinitions: [
                            {
                                name: "dependencyDropDown",
                                displayName: "Dependency Dropdown",
                                editorTemplate: "CheckboxField",
                                defaultValue: false,
                            },
                            {
                                name: "label",
                                displayName: "Drop Down Label",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "value",
                                displayName: "Part# Segement",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "description",
                                displayName: "Description Segement",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "key",
                                displayName: "Dependent Dropdown for KA and Disconnect",
                                editorTemplate: "TextField",
                                defaultValue: "",
                                isVisible: item => item.fields.dependencyDropDown === true,
                            },
                            {
                                name: "id",
                                displayName: "Unique Value",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },

                            {
                                name: "KAValue",
                                displayName: "Dependent Value for KA and Disconnect",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                        ],
                    },
                    {
                        name: "incluededInDynamicPartNumber",
                        displayName: "Included In Dynamic Part Number",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "isRequired",
                        displayName: "Required Field",
                        editorTemplate: "CheckboxField",
                        defaultValue: true,
                    },
                ],
            },
            {
                name: fields.pDFFileName,
                displayName: "PDF File Name",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.pDFPartNumber,
                displayName: "PDF Matching Part Number",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
